module.exports = "<section class=\"breadcrumb\">\n  <div class=\"breadcrumb-box\">\n    <img src=\"../../../assets/icon/address1.svg\" />\n    <span>Home</span>\n    <span *ngFor=\"let list of path\"> > {{list}}</span>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/share/breadcrumb/breadcrumb.component.html
// module id = ../../../../../src/app/share/breadcrumb/breadcrumb.component.html
// module chunks = main